import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { NotificationsService } from '../../services/notifications.service';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { INotificationItem, INotificationItemMenu } from 'src/app/model/notification/notification-item.model';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-modal-notifications',
  templateUrl: './modal-notifications.component.html',
  styleUrls: ['./modal-notifications.component.scss']
})
export class ModalNotificationsComponent implements OnInit {
  selector : string = ".notification-container"
  selector2 : string = ".notification-container2"
  @Output()
  closePanel = new EventEmitter();

  notifications: INotificationItem[] = [];
  notificationsNotRead: INotificationItem[] = [];

  notificationsTemp: INotificationItem[] = [];
  notificationsNotReadTemp: INotificationItem[] = [];

  userId: string = "";

  loading: boolean = false;

  actualTab: number = 0;
  size:number = 10;
  page: number = 1;
  pageAllNotifications: number = 1;
  pageNotRead: number = 1;
  constructor(
    private readonly notificationService: NotificationsService,
    private readonly dataService: DataService,
    private readonly router: Router
    ) { }


  ngOnInit(): void {
    this.userId = `${this.dataService.dataUser.userId}`;
    this.getNotification(0);

  }

  async getNotification(alreadyRead: number) {
    this.loading = true;
    this.page = 1
    this.actualTab = alreadyRead;
    if (alreadyRead === 1) {
      //no leidas
      await this.getOnlyNotReadNotifications();
      this.notificationsNotRead = this.notificationsNotReadTemp;
      this.loading = false;
    } else {
      // todas
      await this.getAllNotifications();
      this.notifications = this.notificationsTemp;
      this.loading = false;
    }
  }


  async getAllNotifications() {
    let notificationsGet = await firstValueFrom(this.notificationService.getAllNotifications(this.userId, this.size, this.page));
    this.notificationsTemp = this.buildNotification(notificationsGet);
  }

  async getOnlyNotReadNotifications() {
    let notificationsGet = await firstValueFrom(this.notificationService.getOnlyNotReadNotifications(this.userId, this.size, this.page));
    this.notificationsNotReadTemp = this.buildNotification(notificationsGet);
  }

  buildNotification(notifications: INotificationItemMenu[]): INotificationItem[] {
    return notifications.map((item: INotificationItemMenu) => ({
      id: item.id,
      alreadyRead: item.read,
      title: item.description,
      date: item.feCreation,
      path: item.pathNotification
    }));
  }

  async onScrollDown(){
    this.page = this.page + 1;
    if(this.actualTab === 1){
      await this.getOnlyNotReadNotifications();
      this.notificationsNotRead = Array.from(new Set([ ...this.notificationsNotRead, ...this.notificationsNotReadTemp]));
    }else{
      await this.getAllNotifications();
      this.notifications = Array.from(new Set([ ...this.notifications, ...this.notificationsTemp]));
    }
  }

  markAllRead() {
    this.notificationService.updateReadAllNotifications(this.userId).subscribe(()=>{
      this.getNotification(this.actualTab);
      this.dataService.setNotificationSse(true);
    })
  }

  goToNotifications() {
    this.closePanel.emit(true);
    this.router.navigateByUrl(`/notifications`);
  }

  onClickNotification($event: INotificationItem){
    this.notificationService.updateReadOnlyNotification($event.id).subscribe(()=> {
      this.closePanel.emit(true);
      this.getNotification(this.actualTab);
      this.dataService.setNotificationSse(true);
      this.router.navigateByUrl($event.path); //path
    })
  }
}
